import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Grid, Row, Col } from 'react-bootstrap';
import { withRouter } from 'react-router';
import axios from 'axios';
import analyticsContext from '../../../experiences/components/analytics/Analytics';
import config from '../../config/config';
import REST_API_NAMES from '../../config/restApiNames';
import OopsErrorMessage from '../../components/OopsErrorMessage/OopsErrorMessage';
import StarSelected from '../../resources/star-selected.svg';
import StarUnselected from '../../resources/star-unselected.svg';
import Emoji1Star from '../../resources/emoji1star.png';
import Emoji2Star from '../../resources/emoji2star.png';
import Emoji3Star from '../../resources/emoji3star.png';
import Emoji4Star from '../../resources/emoji4star.png';
import Emoji5Star from '../../resources/emoji5star.png';
import bootstrapCssUrl from '!file-loader!bootstrap/dist/css/bootstrap.min.css';
import feedbackCSS from '!file-loader?name=[hash].css!extract-loader!css-loader!sass-loader!../../main.scss';
import { getAndSetCampaignDetails } from '../../util/ApiUtil';
import { applyRequiredCapitalizations } from '../../util/TextUtils';
import { theme } from '../../../../themes';
import SafeConsole from '../../util/ConsoleUtils';
import getPartnerAsset, { DynamicAssetsKeys } from '../../../../assets';

// Sample development url: http://localhost:3000/expert-sessions/feedback#99b776j2835

class SurveyFeedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ratingEmoji: null,
      starRating: 0,
      additionalFeedback: '',
      feedbackList: [],
      showErrorMsg: false,
      isPageDisabled: false,
      experienceName: '',
    };

    this.appointmentAPI = {
      url: config.REST_URL(REST_API_NAMES.expertSessionsAppointment),
      payload: {
        idHash: '',
        source: 'survey',
      },
    };

    this.feedbackAPI = {
      url: config.REST_URL(REST_API_NAMES.expertSessionsFeedback),
      payload: {
        customerSessionId: '',
        feedback: [],
        additionalFeedback: '',
        rating: '',
      },
    };

    SafeConsole.log('SurveyFeedback this.appointmentAPI.url = ', this.appointmentAPI.url);
    SafeConsole.log('SurveyFeedback this.feedbackAPI.url = ', this.feedbackAPI.url);
  }

  componentDidMount() {
    const idHash = this.props.location.hash.replace('#', '');

    analyticsContext
      .withAdvancedProps({
        section: 'surveyFeedback',
        idHash,
      })
      .screenEvent();

    if (idHash) {
      this.loadAppointmentData(idHash);
    } else {
      this.props.history.push('/');
    }
  }

  loadAppointmentData = (idHash) => {
    if (!idHash) {
      return false;
    }
    this.appointmentAPI.payload.idHash = idHash;

    axios
      .post(this.appointmentAPI.url, this.appointmentAPI.payload)
      .then((response) => {
        this.feedbackAPI.payload.customerSessionId = response.data.customer_session_id;
        this.setState({ experienceName: response.data.experiences_name });
        this.megaUsecase = response.data.mega_use_case;
        getAndSetCampaignDetails(response.data.engagement_message_id);
      })
      .catch((error) => {
        this.setState({ showErrorMsg: true });
      });
    return true;
  };

  onErrorMessageOkay = (event) => {
    if (!event) {
      return;
    }
    event.preventDefault();
    this.setState({ showErrorMsg: false, isPageDisabled: false });
  };

  onSubmit = (event) => {
    if (!event) {
      return;
    }
    event.preventDefault();
    this.submitSurveyFeedback();
  };

  submitSurveyFeedback = () => {
    this.setState({ isPageDisabled: true }, () => {
      this.feedbackAPI.payload = {
        ...this.feedbackAPI.payload,
        feedback: this.state.feedbackList.map((item) => item.replace(/-/g, ' ')),
        additionalFeedback: this.state.additionalFeedback,
        rating: this.state.starRating,
      };

      analyticsContext
        .withAdvancedProps({
          section: 'surveyFeedback',
          type: 'button',
          text: 'submit feedback',
          action: 'submitSurvey',
          ...this.feedbackAPI.payload,
          experience: this.megaUsecase,
        })
        .controlEvent();

      axios
        .post(this.feedbackAPI.url, this.feedbackAPI.payload)
        .then((response) => {
          const getRoutePath = getPartnerAsset(DynamicAssetsKeys.expertSessionsPath);
          const joinReSearchPath = getRoutePath + '/joinresearchpanel#';
          this.props.history.push(joinReSearchPath + this.feedbackAPI.payload.customerSessionId);
        })
        .catch((error) => {
          this.setState({ showErrorMsg: true });
        });
    });
  };

  onRatingStarClick = (event) => {
    if (!event) {
      return;
    }
    event.preventDefault();
    const starId = event.target.id;
    const starRating = starId.split('-')[1];
    this.setState({ starRating: parseInt(starRating, 10) });
  };

  onImproveButtonClick = (event) => {
    if (!event) {
      return;
    }
    event.preventDefault();

    let feedbackList = this.state.feedbackList;
    const found = this.isFeedbackButtonSelected(event.target.id);
    if (found) {
      feedbackList = feedbackList.filter((item) => item !== event.target.id);
    } else {
      feedbackList.push(event.target.id);
    }
    this.setState({ feedbackList });
  };

  onAddtionalFeedbackChange = (event) => {
    if (!event) {
      return;
    }
    event.preventDefault();
    const additionalFeedback = event.target.value;
    this.setState({ additionalFeedback });
  };

  isFeedbackButtonSelected = (feedbackName) => {
    if (!feedbackName) {
      return false;
    }
    const found = !!this.state.feedbackList.find((item) => item === feedbackName);
    return found;
  };

  renderRatingStars = () => {
    const starsArray = [];
    for (let i = 1; i <= 5; ++i) {
      const starImage = i <= this.state.starRating ? StarSelected : StarUnselected;
      starsArray.push(
        <img
          id={'starIndex-' + i}
          className="RatingStar"
          src={starImage}
          alt="Rating Star"
          onClick={this.onRatingStarClick}
          key={i}
        />
      );
    }
    return <div className="RatingStarsContainer">{starsArray}</div>;
  };

  renderOopsErrorMessage = () => {
    return <OopsErrorMessage onErrorMessageOkay={this.onErrorMessageOkay} />;
  };

  renderRatingEmoji = () => {
    const visibility = this.state.starRating >= 1 && this.state.starRating <= 5 ? 'visible' : 'hidden';
    let emoji = Emoji5Star;
    switch (this.state.starRating) {
      case 1:
        emoji = Emoji1Star;
        break;
      case 2:
        emoji = Emoji2Star;
        break;
      case 3:
        emoji = Emoji3Star;
        break;
      case 4:
        emoji = Emoji4Star;
        break;
      case 5:
        emoji = Emoji5Star;
        break;
    }
    return (
      <div className="RatingEmojiContainer" style={{ visibility: visibility }}>
        <img className="RatingEmoji" src={emoji} alt="Rating Emoji" />
      </div>
    );
  };

  renderTextBreak = (text) => (
    <div className="TextDivider">
      <div className="Text">{text}</div>
    </div>
  );

  renderWhatCanWeImprove = () => {
    const strCallQuality = 'Call-Quality';
    const strLevelofService = 'Level-of-Service';
    const strSupportKnowledge = 'Support-Knowledge';
    const strOther = 'Other';
    const buttonStyle = { color: theme.colors.primaryAccent, borderColor: theme.colors.primaryAccent };
    const selectedbuttonStyle = {
      color: 'white',
      borderColor: theme.colors.primaryAccent,
      backgroundColor: theme.colors.primaryAccent,
    };

    return (
      <div className="ImproveContainer">
        {this.renderTextBreak('What can we improve?')}
        <div className="ImproveButtonsLine">
          <div
            className={'ImproveButton ' + (this.isFeedbackButtonSelected(strCallQuality) ? 'selected' : '')}
            style={this.isFeedbackButtonSelected(strCallQuality) ? selectedbuttonStyle : buttonStyle}
            id={strCallQuality}
            onClick={this.onImproveButtonClick}
          >
            {applyRequiredCapitalizations(strCallQuality.replace(/-/g, ' '))}
          </div>
          <div
            className={'ImproveButton ' + (this.isFeedbackButtonSelected(strLevelofService) ? 'selected' : '')}
            style={this.isFeedbackButtonSelected(strLevelofService) ? selectedbuttonStyle : buttonStyle}
            id={strLevelofService}
            onClick={this.onImproveButtonClick}
          >
            {applyRequiredCapitalizations(strLevelofService.replace(/-/g, ' '))}
          </div>
        </div>
        <div className="ImproveButtonsLine">
          <div
            className={'ImproveButton ' + (this.isFeedbackButtonSelected(strSupportKnowledge) ? 'selected' : '')}
            style={this.isFeedbackButtonSelected(strSupportKnowledge) ? selectedbuttonStyle : buttonStyle}
            id={strSupportKnowledge}
            onClick={this.onImproveButtonClick}
          >
            {applyRequiredCapitalizations(strSupportKnowledge.replace(/-/g, ' '))}
          </div>
          <div
            className={'ImproveButton ' + (this.isFeedbackButtonSelected(strOther) ? 'selected' : '')}
            style={this.isFeedbackButtonSelected(strOther) ? selectedbuttonStyle : buttonStyle}
            id={strOther}
            onClick={this.onImproveButtonClick}
          >
            {applyRequiredCapitalizations(strOther.replace(/-/g, ' '))}
          </div>
        </div>
      </div>
    );
  };

  renderAdditionalFeedback = () => {
    return (
      <div className="AdditionalFeedbackContainer">
        {this.renderTextBreak('Additional Feedback')}
        <textarea
          id="FeedbackTextArea"
          placeholder="You can provide additional feedback here..."
          value={this.state.additionalFeedback}
          onChange={this.onAddtionalFeedbackChange}
        />
      </div>
    );
  };

  render() {
    const visibility = this.state.starRating ? 'visible' : 'hidden';
    const buttonStyles = { backgroundColor: theme.colors.primaryAccent, borderColor: theme.colors.primaryAccent };
    return (
      <div
        className="FeedbackBackgroundContainer"
        style={{
          backgroundImage: `linear-gradient(to bottom, ${theme.colors.featureSection2}, ${
            theme.colors.featureSection2
          })`,
        }}
      >
        <Grid>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Helmet defer={false}>
                <link rel="stylesheet" type="text/css" href={bootstrapCssUrl} />
                <link rel="stylesheet" type="text/css" href={feedbackCSS} />
              </Helmet>
              <div className="SurveyFeedbackContainer">
                <div className="Title">{this.state.experienceName} Feedback</div>
                <div className="RatingContainer">
                  <div className="Text">How would you rate your experience?</div>
                  {this.renderRatingStars()}
                  {this.renderRatingEmoji()}
                </div>
                <div style={{ visibility: visibility }}>
                  {this.renderWhatCanWeImprove()}
                  {this.renderAdditionalFeedback()}
                </div>
                <div className="SubmitButtonContainer">
                  <button
                    onClick={this.onSubmit}
                    disabled={!this.state.starRating || this.state.isPageDisabled}
                    className={this.state.isPageDisabled ? 'waiting' : ''}
                    style={buttonStyles}
                  >
                    {applyRequiredCapitalizations('Submit Feedback')}
                  </button>
                </div>
              </div>
              {this.state.showErrorMsg && this.renderOopsErrorMessage()}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default withRouter(SurveyFeedback);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/pages/SurveyFeedback/SurveyFeedback.js